import {Observable, Observer} from 'rxjs';
import {Injectable} from '@angular/core';
import {AceLoggerService} from '@logging/ace-logger.service';
import {AceLogger} from '@logging/ace-logger';


// Using the API Key in JavaScript code inside a URL is how Google recommends the API keys to be used:
// https://developers.google.com/maps/documentation/javascript/adding-a-google-map#key
// This approach is not very secure (as our users could steal the key), but restricting what the key can do, and
// rotating it, is the only recommendation from Google
const key = 'AIzaSyBhaGU4Z440GH7C3iz_2opcqFQubqJSbJY';
const url = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=__onGoogleLoaded&libraries=marker`;

@Injectable({providedIn: 'root'})
export class GoogleMapsService {

  private readonly logger: AceLogger;
  private static promise;
  private geocoder: google.maps.Geocoder;

  // Obtained from the Google Maps Platform Dashboard https://console.cloud.google.com/google/maps-apis/overview?inv=1&invt=Abj5Iw&project=sitemanager-1500450696136.
  // Moved from MapFormComponent
  readonly DEFAULT_GOOGLE_MAPS_ID = '5beb74884107478b';

  constructor(logService: AceLoggerService) {
    this.logger = logService.create(GoogleMapsService.name);
  }

  public load() {
    // First time 'load' is called?
    if (!GoogleMapsService.promise) {

      // Make promise to load
      GoogleMapsService.promise = new Promise( resolve => {

        // Set callback for when google maps is loaded.
        window['__onGoogleLoaded'] = (ev) => {

          this.geocoder = new google.maps.Geocoder();

          resolve('google maps api loaded');
        };

        const node = document.createElement('script');
        node.src = url;
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);

      });
    }

    // Always return promise. When 'load' is called many times, the promise is already resolved.
    return GoogleMapsService.promise;
  }

  geocode(address: string): Observable<google.maps.GeocoderResult[]> {
    return new Observable<google.maps.GeocoderResult[]>((observer: Observer<google.maps.GeocoderResult[]>) => {
        this.geocoder.geocode({ address: address }, (
            (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    observer.next(results);
                    observer.complete();
                } else {
                    this.logger.error('GoogleMapsService Error: ' + status);
                    observer.error(status);
                }
            })
        );
    });
}


}
